import React from "react";
import "./DiscardNoteEdit.css";

function DiscardNoteEdit(props: {callback: () => void}): JSX.Element {
    return (
        <div className="discardNoteEdit" onClick={props.callback}>
            <p className="discardNoteEditText">Discard</p>
        </div>
    )
}

export default DiscardNoteEdit;